import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIssuesDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M18 4.5V19.5L9 16.125V7.875L18 4.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M9 8H5C3.89543 8 3 8.89543 3 10V14C3 15.1046 3.89543 16 5 16H9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M6 16.5L7 21H9.5L8.5 16.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M20.5 10.5C21.1667 11.1667 21.1667 12.8333 20.5 13.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgIssuesDefault;
